import { useQuery } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { readComplianceBody } from "../helper/readComplianceBody";
import type { DuplicateIdentityGroupDetail } from "./types";

type StoredToken = { AccessToken?: string };

export const GET_DUPLICATE_IDENTITY_GROUP_DETAIL_QUERY_KEY =
  "GET_DUPLICATE_IDENTITY_GROUP_DETAIL";

export async function fetchDuplicateIdentityGroupDetail(
  groupId: string,
): Promise<DuplicateIdentityGroupDetail | undefined> {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
  );

  const url = API_ROUTES.GET_DUPLICATE_IDENTITY_GROUP_DETAIL.replace(
    "{group_id}",
    encodeURIComponent(groupId),
  );

  const response = await PrivateAdminPanelInstance.get(url);
  return readComplianceBody<DuplicateIdentityGroupDetail>(response);
}

export const useGetDuplicateIdentityGroupDetail = (
  groupId: string | null,
  enabled = true,
) => {
  return useQuery({
    queryKey: [GET_DUPLICATE_IDENTITY_GROUP_DETAIL_QUERY_KEY, groupId],
    queryFn: () => fetchDuplicateIdentityGroupDetail(groupId as string),
    enabled: Boolean(groupId) && enabled,
    staleTime: 1000 * 30,
    refetchOnWindowFocus: false,
  });
};
